import * as React from "react";

export const MEDIA_QUERY_MOUSE          = "all and (any-pointer: fine)";
export const MEDIA_QUERY_SM             = "(max-width: 640px)";
export const MEDIA_QUERY_MD_AND_OVER    = "(min-width: 641px)";
export const MEDIA_QUERY_MD             = "(max-width: 1023px)";

type ViewportTestProps = {
    if    : string,
    then ?: () => React.ReactNode,
    else ?: () => React.ReactNode,
};

export class ViewportTest extends React.Component<ViewportTestProps, {matches: boolean}> {
    private mediaQueryList:MediaQueryList;
    private handleMediaQueryChange:(e:MediaQueryListEvent) => void;

    constructor(props:ViewportTestProps) {
        super(props);
        this.handleMediaQueryChange = ({matches}:MediaQueryListEvent) => this.state && this.setState({matches});
        this.mediaQueryList         = window.matchMedia(props.if);
        this.state                  = {matches: this.mediaQueryList.matches};
    }

    componentDidMount() {
        this.watchMedia();
    }

    componentDidUpdate() {
        if (this.mediaQueryList.media !== this.props.if) {
            this.unwatchMedia();
            this.mediaQueryList = window.matchMedia(this.props.if);
            this.watchMedia();

            if (this.state.matches !== this.mediaQueryList.matches) {
                this.state && this.setState({matches: this.mediaQueryList.matches});
            }
        }
    }

    unwatchMedia() {
        this.mediaQueryList.removeEventListener("change", this.handleMediaQueryChange);
    }

    watchMedia() {
        this.mediaQueryList.addEventListener("change", this.handleMediaQueryChange);
    }

    render() {
        return this.state.matches
            ? ("then" in this.props ? this.props.then() : this.props.children)
            : this.props.else?.() ?? false
        ;
    }
}
